import type { TOC } from '@ember/component/template-only';
import { VStack } from './layout.gts';

interface FilterRailSignature {
  Args: {
    /** Accessible name for the rail (the visual heading is intentionally
     * omitted — pass a translated string, e.g. `{{t "people.filters"}}`). */
    label: string;
  };
  Element: HTMLElement;
  Blocks: { default: [] };
}

/**
 * Filter surface stays sticky at lg and above, static above results below lg. The caller controls
 * grid placement and width; keep filters accessible on small screens.
 */
const FilterRail: TOC<FilterRailSignature> = <template>
  <aside data-test-filter-rail class="app-filter-rail" aria-label={{@label}} ...attributes>
    {{! collapsed — VStack's default 1rem padding would stack on top of the
        rail's own padding }}
    <VStack @collapsed={{true}}>
      {{yield}}
    </VStack>
  </aside>
</template>;

export default FilterRail;
